module.exports = __webpack_public_path__ + "static/img/product-Business-Intelligence-img-768x591.5c4632a2.png";